import withMediaControl from 'EditorWidgets/withMedia/withMediaControl';

const ImageControl = withMediaControl(true);

export default ImageControl;



// WEBPACK FOOTER //
// ./components/EditorWidgets/Image/ImageControl.js